import { useEffect, useState } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import useConfig from 'hooks/useConfig';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

// types
import { RootStateProps } from 'types/root';
import { openDrawer } from 'store/reducers/menu';

// store
import { useSelector } from 'store';

// hooks
import useFilteredMenuItems from 'hooks/useMenuItems';
import { CityBillsUploadProgressList } from '../../components/city-bills-uploader';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
  const navigation = useFilteredMenuItems();

  const { container, miniDrawer } = useConfig();
  const dispatch = useDispatch();

  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;

  const location = useLocation();
  const isCompanyHome = location.pathname.startsWith('/dashboard');

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG);
      dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  const isExceptionPage = exceptionPaths.some((path) => location.pathname.startsWith(path));

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <ScrollRestoration />
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar />
        {container && (
          <Container
            maxWidth={false}
            sx={{
              px: { xs: 0, sm: 2 },
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column',
              maxWidth: isExceptionPage ? 1200 : 2400
            }}
          >
            {!isCompanyHome && <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />}
            <Outlet />
            <Footer />
          </Container>
        )}
        {!container && (
          <Box sx={{ position: 'relative', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' }}>
            {!isCompanyHome && <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />}
            <Outlet />
            <Footer />
          </Box>
        )}
      </Box>
      <CityBillsUploadProgressList />
    </Box>
  );
};

export default MainLayout;

const exceptionPaths = ['/settings'];
